import { formatNumberToShort } from '../../helpers'

export const getCustomDataLabelsOptions = ({ maxValue, fontSize = 14, currencySymbol = '' }) => {
  return {
    display: ctx => {
      const currentValue = ctx.dataset.data[ctx.dataIndex]
      // only show if current value is more than 10% of max value,
      // (because when it's less - label is cut off by the bar, and not visible)
      return currentValue > maxValue / 10
    },
    formatter: value =>
      currencySymbol ? `${currencySymbol}${formatNumberToShort(value)}` : formatNumberToShort(value),
    color: 'white',
    borderColor: 'white',
    borderWidth: 3,
    borderRadius: 4,
    padding: {
      top: 2,
      right: 4,
      bottom: 2,
      left: 4
    },
    align: 'start',
    anchor: 'end',
    font: {
      size: fontSize
    }
  }
}
